import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getVerifyPurReq } from '../../../Store/Admin/VerifyPurRquest/getVerifyPurReq';
import Header from '../Include/Header';
import Sidebar from '../Include/Sidebar';
import Footer from '../Include/Footer';
import Loader from '../Include/Loader';
import { Pagination, Search } from '../Table';
import DropDown from '../../../Components/DropDown';
import moment from 'moment';
import { Check, X } from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { V_URL } from '../../../BaseUrl';

const PurRequestList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('VA_TOKEN') === null) {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
    if (disable === true) {
      dispatch(getVerifyPurReq({ payload: { tag_number: 9 } }));
      setDisable(false);
    }
  }, [disable, navigate]);

  const entity = useSelector((state) => state?.getVerifyPurReq?.user?.data);

  const commentsData = useMemo(() => {
    let computedComments = entity;

    if (search) {
      computedComments = computedComments.filter(
        (pur) =>
          pur.deaprtment?.toLowerCase()?.includes(search?.toLowerCase()) ||
          pur.voucher_no?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, entity]);

  const handleRefresh = () => {
    setDisable(true)
  }

  const handleApprove = async (id, voucherNo, status) => {
    if (status === 3) {
      // Rejection flow
      const { value: reason } = await Swal.fire({
        title: `Reject PR - ${voucherNo}`,
        input: 'textarea',
        inputLabel: 'Reason for Rejection',
        inputPlaceholder: 'Type the rejection reason...',
        inputAttributes: {
          'aria-label': 'Type your rejection reason here'
        },
        showCancelButton: true,
        confirmButtonText: 'Reject',
        confirmButtonColor: '#e74c3c',
        cancelButtonColor: '#6c757d',
      });

      if (!reason) {
        Swal.fire('Cancelled', 'Rejection was cancelled or no reason was provided.', 'info');
        return;
      }

      const payload = {
        id,
        admin_email: localStorage.getItem("VA_EMAIL"),
        accrej_time: moment().format("HH:mm"),
        rej_reason: reason,
        status: 4
      };

      try {
        const myurl = `${V_URL}/admin/pro-approve-one-pr`;
        await axios({
          method: 'post',
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem('VA_TOKEN')
          },
        })
        Swal.fire('Rejected!', 'Purchase Request has been rejected.', 'success');
        setDisable(true);
      } catch (err) {
        console.error(err);
        Swal.fire('Error!', 'Something went wrong while rejecting.', 'error');
      }

    } else if (status === 2) {
      // Approval flow
      const result = await Swal.fire({
        title: `Approve PR - ${voucherNo}`,
        text: "Are you sure you want to approve this request?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
      });

      if (!result.isConfirmed) return;

      const payload = {
        id,
        admin_email: localStorage.getItem("VA_EMAIL"),
        accrej_time: moment().format("HH:mm"),
        // rej_reason: '',
        status: 3
      };

      try {
        const myurl = `${V_URL}/admin/pro-approve-one-pr`;
        await axios({
          method: 'post',
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem('VA_TOKEN')
          },
        })
        Swal.fire('Approved!', 'Purchase Request has been approved.', 'success');
        setDisable(true);
      } catch (err) {
        console.error(err);
        Swal.fire('Error!', 'Something went wrong while approving.', 'error');
      }
    }
  };


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">

          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard </Link></li>
                  <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                  <li className="breadcrumb-item active">Purchase Request List</li>
                </ul>
              </div>
            </div>
          </div>

          {disable === false ? (
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">

                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Purchase Request List</h3>
                            <div className="doctor-search-blk">
                              <div className="top-nav-search table-search-blk">
                                <form>
                                  <Search
                                    onSearch={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                    }} />
                                  <button className="btn"><img src="/assets/img/icons/search-normal.svg"
                                    alt="search" /></button>
                                </form>
                              </div>
                              <div className="add-group">
                                <button type='button' onClick={handleRefresh}
                                  className="btn btn-primary doctor-refresh ms-2" data-toggle="tooltip" data-placement="top" title="Refresh"><img
                                    src="/assets/img/icons/re-fresh.svg" alt="refresh-icon" /></button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                          <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0 datatable">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>PR Date</th>
                            <th>PR No.</th>
                            <th>Department</th>
                            <th>Project No</th>
                            <th>Project</th>
                            <th>Prepared By</th>
                            <th>Approved By</th>
                            <th>Item Count</th>
                            <th>Status</th>
                            <th>Acc/Rej</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) =>
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>{moment(elem.trans_date).format('YYYY-MM-DD')}</td>
                              <td>{elem.voucher_no}</td>
                              <td>{elem.department_name || '-'}</td>
                              {/* <td>{elem?.project_details?.project_no || '-'}</td> */}
                              <td>{elem?.manual_pro_no || "-"}</td>
                              <td>{`${elem.project_details?.name} ${
                                  elem.project_details?.project_no
                                    ? `(${elem.project_details?.project_no})`
                                    : ""
                                }` || "-"}</td>
                              <td>{elem?.prepare_by?.name || '-'}</td>
                              <td>{elem?.approve_by?.name || '-'}</td>
                              <td>{elem.item_count || 0}</td>
                              <td>
                                {elem.status === 1 ? (
                                  <span className="custom-badge status-orange">Pending</span>
                                ) : elem.status === 2 ? (
                                  <span className="custom-badge status-yellow">Verified</span>
                                ) : elem.status === 3 ? (
                                  <span className="custom-badge status-green">Approved By Admin</span>
                                ) : elem?.status === 4 ? (
                                  <span className="custom-badge status-pink">Rejected</span>
                                ) : <span>Unknown</span>}
                              </td>
                              <td className='d-flex gap-2'>
                                {elem.status === 2 ? (
                                  <>
                                    <span className='present-table attent-status' style={{ cursor: 'pointer' }} onClick={() => handleApprove(elem._id, elem?.voucher_no, 2)}><Check /></span>
                                    <span className='absent-table attent-status' style={{ cursor: 'pointer' }} onClick={() => handleApprove(elem._id, elem?.voucher_no, 3)}><X /></span>
                                  </>
                                ) : (<X />)}
                              </td>
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown" aria-expanded="false"><i
                                      className="fa fa-ellipsis-v"></i></a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button type='button' className="dropdown-item" onClick={() => navigate('/admin/view-pr', { state: elem })}><i
                                      className="fa-solid fa-eye m-r-5"></i>
                                      View</button>

                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}

                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colspan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                    <div className="row align-center mt-3 mb-2">
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                          aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                        <div className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate">
                          <Pagination
                            total={totalItems}
                            itemsPerPage={limit}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : <Loader />}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default PurRequestList